import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/outcome/importer/outcomeImporterActions';

export default importerReducers(actions);
